<!--
무게/부피를 입력하는 컴포넌트
-->
<template>
    <div class="root uk-flex uk-flex-bottom">
        <!-- 패키지 -->
        <div class="uk-width-expand uk-position-relative">


            <package
                v-for="(pkg, index) in items"
                :key="index"
                :index="index"

                :unit="unit"
                :volume-unit="volumeUnit"
                :package="pkg"
                :disable-remove-btn="items.length <= 1"
            >
                <!-- 무게 미입력 안내화면 -->
                <slot name="empty-screen" slot="empty-screen"></slot>
            </package>
        </div>



        <!-- 패키지 수량 안내-->
        <div class="uk-margin-small-left">
            <div class="">
                {{ packageCountTitle }} : <span class="uk-text-primary ">{{ items.length }}</span>
                <span class="uk-text-muted">({{ packageCountDesc }})</span>
            </div>

            <!-- 추가버튼 -->
            <div class="uk-text-right">
                <button
                    class="uk-button uk-button-white"
                    v-on:click="add"
                >
                    <i class="material-icons">add</i>
                    {{ addButtonText }}
                </button>
            </div>
        </div>


        <!-- 수정 modal 창 -->
        <div class="modal-package uk-flex-top" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical">

                <div class="uk-modal-body">


                    <!-- 무게/부피-->
                    <div
                        class="uk-flex uk-flex-left"
                    >
                        <div class="cell weight">
                            <h4>무게</h4>
                            <input-text
                                class="first-focus uk-width-1-1"
                                ref="w"
                                v-model="modalPackage.weight"
                                @save="$refs.x.inputFocus()"
                                @next="$refs.x.inputFocus()"
                            />
                            <span class="unit">{{ unit }}</span>
                        </div>

                        <div class="cell"></div>

                        <div class="cell volume">
                            <h4>가로</h4>
                            <input-text
                                type="text"
                                class="uk-width-1-1"
                                ref="x"
                                v-model="modalPackage.volume_x"
                                @prev="$refs.w.inputFocus()"
                                @save="$refs.y.inputFocus()"
                                @next="$refs.y.inputFocus()"
                            />
                            <span class="unit">{{ volumeUnit }}</span>
                        </div>

                        <div class="cell volume">
                            <h4>세로</h4>
                            <input-text
                                class="uk-width-1-1"
                                ref="y"
                                v-model="modalPackage.volume_y"
                                @prev="$refs.x.inputFocus()"
                                @save="$refs.z.inputFocus()"
                                @next="$refs.z.inputFocus()"
                            />
                            <span class="unit">{{ volumeUnit }}</span>
                        </div>

                        <div class="cell volume">
                            <h4>높이</h4>
                            <input-text
                                type="text"
                                class="uk-width-1-1 uk-input"
                                ref="z"
                                v-model="modalPackage.volume_z"
                                @prev="$refs.y.inputFocus()"
                                @save="savePackage"

                            />
                            <span class="unit">{{ volumeUnit }}</span>
                        </div>

                    </div>

                </div>


                <div class="uk-modal-footer uk-text-right">

                    <!-- 중간무게 컨펌처리 -->
                    <div class="medium-confirm-msg" v-show="modalMediumWeightConfirmState  === 'need'">
                        {{ mediumWeightConfirmMsg }}

                        <br/>
                        <!-- 컨펌 확인 버튼 -->
                        <button
                            class="uk-button uk-button-primary"
                            type="button"
                            v-on:click="confirmMediumWeight"
                        >
                            <i class="material-icons">
                                check_circle_outline
                            </i>
                            {{ mediumWeightConfirmButton }}
                        </button>
                    </div>

                    <!-- 큰 무게 컨펌처리 -->
                    <div class="heavy-confirm-msg" v-show="modalHeavyWeightConfirmState === 'need'">
                        {{ heavyWeightConfirmMsg }}
                        <!-- 컨펌 확인 버튼 -->
                        <div class="uk-flex uk-flex-left">
                            <div class="cell">
                                <input-text
                                    type="text"
                                    class="uk-width-1-1"
                                    v-model="confirmInputs.w"
                                    ref="confirm_w"
                                    @save="confirmHeavyWeight"
                                    placeholder="무게"
                                />
                            </div>
                        </div>

                        <button
                            class="uk-button uk-button-primary uk-width-1-1"
                            type="button"
                            v-on:click="confirmHeavyWeight"
                        >
                            <i class="material-icons">check</i>
                            WEIGHT CONFIRM
                        </button>
                    </div>

                    <!-- 큰 부피 컨펌처리 -->
                    <div class="large-volume-confirm-msg" v-show="modalVolumeConfirmState === 'need'">
                        부피가 큰 화물입니다. 입력한 부피가 정확합니까/?
                        <!-- 컨펌 확인 버튼 -->
                        <div class="uk-flex uk-flex-left">
                            <div class="cell"></div>
                            <div class="cell"></div>
                            <div class="cell">
                                <input-text
                                    type="text"
                                    class="uk-width-1-1"
                                    ref="confirm_x"
                                    v-model="confirmInputs.x"
                                    @save="$refs.confirm_y.inputFocus()"
                                    @next="$refs.confirm_y.inputFocus()"
                                    placeholder="가로"
                                />
                            </div>

                            <div class="cell">
                                <input-text
                                    type="text"
                                    class="uk-width-1-1"
                                    ref="confirm_y"
                                    v-model="confirmInputs.y"
                                    @prev="$refs.confirm_x.inputFocus()"
                                    @save="$refs.confirm_z.inputFocus()"
                                    @next="$refs.confirm_z.inputFocus()"
                                    placeholder="세로"
                                />
                            </div>

                            <div class="cell">
                                <input-text
                                    type="text"
                                    class="uk-width-1-1"
                                    ref="confirm_z"
                                    v-model="confirmInputs.z"
                                    @prev="$refs.confirm_y.inputFocus()"
                                    @save="confirmLargeVolume"
                                    placeholder="높이"
                                />
                            </div>
                        </div>

                        <button
                            class="uk-button uk-button-primary uk-width-1-1"
                            type="button"
                            v-on:click="confirmLargeVolume"
                        >
                            <i class="material-icons">check</i>
                            VOLUME CONFIRM
                        </button>
                    </div>

                    <!-- 버튼 -->
                    <button
                        class="uk-button uk-button-default uk-modal-close"
                        type="button"
                    >
                        <i class="material-icons">close</i>
                        CANCEL
                    </button>
                    <button
                        class="uk-button uk-button-primary"
                        type="button"
                        v-on:click="savePackage"
                        :disabled="! modalAllConfirmed"
                    >
                        <i class="material-icons">check</i>
                        SAVE
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    components: {
        'package': require('./package.vue').default,
        'input-text': require('./text.vue').default,
    },
    props: {
        /**
         * 사용단위 (기본값)
         * - kg : kg, cm 사용
         * - lb : lb(파운드), in(인치) 사용
         */
        defaultUnit: {
            type: String,
            default: 'kg',
        },

        /**
         * 중간무게
         *
         * 중간무게를 초과하면, 컨펌메세지 처리함.
         */
        mediumWeight: {
            type: Number,
            default: 10
        },
        /**
         * 무게 체크 컨펌메세지
         */
        mediumWeightConfirmMsg: {
            type: String,
            default: '무거운 화물입니다. 입력한 무게가 정확합니까?'
        },
        heavyWeightConfirmMsg: {
            type: String,
            default: '굉장히 무거운 화물입니다. 무게를 다시 한번 입력하세요'
        },
        /**
         * 무게 체크 컨펌 확인 버튼
         */
        mediumWeightConfirmButton: {
            type: String,
            default: '예, 정확히 확인하였습니다.'
        },
        /**
         * 굉장히 큰 무게
         *
         * 큰 무게를 초과하면
         * 한번 더 똑같은 무게를 입력받도록 해서, 입력방법을 어렵게해서, 실수하지 않도록 함.
         */
        heavyWeight: {
            type: Number,
            default: 30
        },
        /**
         * 큰 부피
         *
         * 큰 부피를 초과하면
         * 한번 더 똑같은 부피를 입력받도록 해서, 입력방법을 어렵게해서, 실수하지 않도록 함.
         */
        largeVolume: {
            type: Number,
            default: 100
        },
        packageCountTitle: {
            type: String,
            default: '패키지 수'
        },
        packageCountDesc: {
            type: String,
            default: '실제 패키지 수와 동일해야 합니다'
        },
        addPackageDesc: {
            type: String,
            default: '실제 패키지 수와 동일해야 합니다'
        },
        packageClickTooltip: {
            type: String,
            default: '클릭해서, 무게/부피를 입력합니다'
        },
        needInputText: {
            type: String,
            default: 'INPUT'
        },

        addButtonText: {
            type: String,
            default: 'ADD PACKAGE'
        },
        duplicateButtonText: {
            type: String,
            default: '복사'
        },
        removeButtonText: {
            type: String,
            default: 'REMOVE'
        },
        removeConfirm: {
            type: String,
            default: '정말 삭제하겠습니까?'
        },
        lastItemRemoveAlert: {
            type: String,
            default: '마지막 패키지는 삭제할 수 없습니다.'
        },
        validateMsgNeedWeight: {
            type: String,
            default: '무게는 반드시 입력해야 합니다'
        },

        /**
         * 외부에서 이 컴포넌트에 접근하기위해 등록될 전역변수명
         */
        globalVnodeName: {
            type: String,
            default: 'packages'
        },

        /**
         * 초기 packages 정보
         *
         * 예 )
         * [
         *    {weight: 1, volume_x: 1, volume_y: 1, volume_z: 1, volume_weight: 1, apply_weight: 1},
         *    {weight: 1, volume_x: 1, volume_y: 1, volume_z: 1, volume_weight: 1, apply_weight: 1},
         * ]
         */
        packages: {
            type: Array,
            default: function () {
                return [];
            }
        },

        /**
         * 초기에 바로 수정모드를 실행해서 무게를 바로 입력할 수 있도록 함.
         */
        initializeEditMode: {
            type: Boolean,
            default: false,
        },

        // 지역ID
        regionId: {
            type: Number,
            default: null,
        },


    },
    data: function () {
        // todo : 기존에 오레곤에 키로만 저장된 경우에는 lb로 선택되서 이상하게 표시됨.
        // 무게단위 결정
        let unit = this.defaultUnit;
        if (this.packages.length > 0 && this.packages[0].has_lb) {
            unit = 'lb';
        }

        // 부피무게 변환계수
        // TASK-136 : 캐나다(2센터) 5000 특례 제거 — 전 센터 6000 단일화 원복
        let volumeWeightConversionFactor = 6000;


        return {
            // 무게단위
            unit: unit,

            // 패키지정보 배열
            items: this.packages,

            // 모달창 정보
            modalPackage: {
                index: null,// 현재 모달창에 설정된 패키지의 index
                confirmedMediumWeight: null,// 사용자가 컨펌과정을 마친 중간 무게
                confirmedHeavyWeight: null,// 사용자가 컨펌과정을 마친 큰 무게
                confirmedVolumeX: null,
                confirmedVolumeY: null,
                confirmedVolumeZ: null,


                weight: null,
                volume_x: null,
                volume_y: null,
                volume_z: null,

                orig_weight: null,
                orig_volume_x: null,
                orig_volume_y: null,
                orig_volume_z: null,
            },

            // 컨펍입력 input
            confirmInputs: {
                w: null,
                x: null,
                y: null,
                z: null,
            },

            /**
             * 부피무게 변환계수
             */
            volumeWeightConversionFactor: volumeWeightConversionFactor,

        };
    },
    computed: {


        // 부피단위
        volumeUnit() {
            return this.unit === 'kg' ? 'cm' : 'in';
        },

        /**
         * 모달창에서 수정한 무게에대해서 컨펌여부를 반환
         * @return string
         *      - 'yet' : 아직 이전단계 컨펌이 완료되지 않음
         *      - 'need' : 컨펌이 필요함
         *      - 'done' : 컨펌완료
         */
        modalMediumWeightConfirmState: function () {

            // 입력무게
            let weight = this.parseNumber(this.modalPackage.weight);

            // 기존 무게에서 수정이 안된경우
            if (weight === this.modalPackage.orig_weight) {
                return 'done';
            }

            // 기준 무게 초과
            if (weight >= this.mediumWeight) {
                // 이전에 컨펌통과했던 무게와 일치하는지
                let confirmed = this.parseNumber(this.modalPackage.confirmedMediumWeight);
                //console.log(weight);
                //console.log(confirmed);
                if (weight !== confirmed) {
                    return 'need';
                }
            }
            return 'done';
        },

        /**
         * 모달창 큰 무게 컨펌여부
         * @return string
         *      - 'yet' : 아직 이전단계 컨펌이 완료되지 않음
         *      - 'need' : 컨펌이 필요함
         *      - 'done' : 컨펌완료
         */
        modalHeavyWeightConfirmState: function () {
            // 이전단계 컨펌완료되었나 체크
            if (this.modalMediumWeightConfirmState !== 'done') {
                return 'yet';
            }

            // 입력무게
            let weight = this.parseNumber(this.modalPackage.weight);

            // 기존 무게에서 수정이 안된경우
            if (weight === this.modalPackage.orig_weight) {
                return 'done';
            }

            // 기준 무게 초과
            if (weight >= this.heavyWeight) {
                // 이전에 컨펌통과했던 무게와 일치하는지
                let confirmed = this.parseNumber(this.modalPackage.confirmedHeavyWeight);
                if (weight !== confirmed) {
                    return 'need';
                }
            }
            return 'done';
        },

        /**
         * 모달창 부피 컨펌여부
         * @return string
         *      - 'yet' : 아직 이전단계 컨펌이 완료되지 않음
         *      - 'need' : 컨펌이 필요함
         *      - 'done' : 컨펌완료
         */
        modalVolumeConfirmState: function () {
            // 이전단계 컨펌완료되었나 체크
            if (this.modalHeavyWeightConfirmState !== 'done') {
                return 'yet';
            }

            // 입력값
            let volume_x = this.parseNumber(this.modalPackage.volume_x);
            let volume_y = this.parseNumber(this.modalPackage.volume_y);
            let volume_z = this.parseNumber(this.modalPackage.volume_z);

            // 기존값에서 수정이 안된경우
            if (volume_x === this.modalPackage.orig_volume_x
                && volume_y === this.modalPackage.orig_volume_y
                && volume_z === this.modalPackage.orig_volume_z
            ) {
                return 'done';
            }

            // 기준 부피 초과
            if (volume_x >= this.largeVolume
                || volume_y >= this.largeVolume
                || volume_z >= this.largeVolume
            ) {
                // 이전에 컨펌통과했던 부피와 일치하는지
                let confirmed_x = this.parseNumber(this.modalPackage.confirmedVolumeX);
                let confirmed_y = this.parseNumber(this.modalPackage.confirmedVolumeY);
                let confirmed_z = this.parseNumber(this.modalPackage.confirmedVolumeZ);
                if (volume_x !== confirmed_x
                    || volume_y !== confirmed_y
                    || volume_z !== confirmed_z
                ) {
                    return 'need';
                }
            }
            return 'done';
        },

        /**
         * 모달창 모든 컨펌여부
         * @return boolean true : 컨펌처리 완료(컨펌 필요없음) / false : 컨펌과정 필요함.
         */
        modalAllConfirmed: function () {
            return this.modalVolumeConfirmState === 'done';
        },


        /**
         * 총 무게정보
         *  - 총 무게
         *  - 총 부피무게
         *  - 총 적용무게 ( 무게와 부피중 큰 값)
         * @return Object {weight, volume_weight, apply_weight}
         */
        totalWeight() {
            let weight = 0;
            let volume_weight = 0;
            let apply_weight = 0;
            _.each(this.items, (item) => {
                weight += this.parseNumber(item.weight);
                volume_weight += this.parseNumber(item.volume_weight);
            });

            // 소수점계산 뒤에 00000003 붙어서 반올림 처리함. 나중에 완전세밀하게해야되면, float plus 함수만들어서 사용해야함
            weight = _.round(weight, 2);
            volume_weight = _.round(volume_weight, 2);

            if (weight < volume_weight) {
                apply_weight = volume_weight;
            } else {
                apply_weight = weight;
            }

            return {
                weight,
                volume_weight,
                apply_weight,
            };
        },


    },
    watch: {
        /**
         * 총무게  이벤트 발생
         */
        totalWeight(value) {
            this.$emit('total-weight', value);
        },
    },
    mounted: function () {

        // 기존 패키지 초기 무게계산
        _.forEach(this.items, (item, index) => {
            this.calcVolume(item, this.unit);
            Vue.set(this.items, index, item);
        });
        //this.items = [];
        //this.items = this.packages;

        // 첫 패키지 하나 기본 추가
        if (this.items.length === 0) {
            this.add({
                weight: null,
                volume_x: null,
                volume_y: null,
                volume_z: null,
                volume_weight: null,
                apply_weight: null,
            });
        }





        // 전역에 현재 컴포넌트 등록
        window[this.globalVnodeName] = this;

        // 현재 vnode 에 모달창 html 엘리먼트 등록해둠. (창을 반복적으로 띄울때 필요함)
        this.$modalElement = $(this.$el).find('.modal-package');


        // 초기 에디트모드 실행
        if (this.initializeEditMode) {
            this.editPackage(0);
        }

    },
    methods: {

        /**
         * 값을 무조건 숫자로 변환해줌. (이상한값 전부 0처리)
         * - float 으로 만들어줌.
         * - NaN 은 0으로 리턴 .
         */
        parseNumber: function (num) {
            num = parseFloat(num);
            if (isNaN(num)) {
                return 0;
            }
            return num;
        },
        /**
         * 중간무게 컨펌처리
         */
        confirmMediumWeight: function () {
            this.modalPackage.confirmedMediumWeight = this.modalPackage.weight;
        },
        /**
         * 큰 무게 컨펌처리
         */
        confirmHeavyWeight: function () {
            // 컨펌입력값을 저장
            this.modalPackage.confirmedHeavyWeight = this.confirmInputs.w;
        },
        /**
         * 큰 부피 컨펌처리
         */
        confirmLargeVolume: function () {
            // 컨펌입력값을 저장
            this.modalPackage.confirmedVolumeX = this.confirmInputs.x;
            this.modalPackage.confirmedVolumeY = this.confirmInputs.y;
            this.modalPackage.confirmedVolumeZ = this.confirmInputs.z;
        },
        /**
         * 패키지 수정
         *  - modal 창 띄움.
         */
        editPackage: function (index) {
            // 패키지 정보 설정
            let pkg = this.items[index];
            this.modalPackage = {
                index: index,
                confirmedMediumWeight: null,
                confirmedHeavyWeight: null,
                confirmedVolumeX: null,
                confirmedVolumeY: null,
                confirmedVolumeZ: null,

                weight: pkg.weight,
                volume_x: pkg.volume_x,
                volume_y: pkg.volume_y,
                volume_z: pkg.volume_z,

                orig_weight: this.parseNumber(pkg.weight), // 원본 무게
                orig_volume_x: this.parseNumber(pkg.volume_x),
                orig_volume_y: this.parseNumber(pkg.volume_y),
                orig_volume_z: this.parseNumber(pkg.volume_z),
            };
            this.confirmInputs = {
                w: null,
                x: null,
                y: null,
                z: null,
            };

            // 초기화
            this.$modalElement.find('.heavy-weight-confirm').val('');

            // 창 띄움
            UIkit.modal(this.$modalElement).show();

            // 무게input에 포커싱
            this.$modalElement.find('input.first-focus').focus();
        },
        /**
         * 패키지 수정정보 저장
         *  - modal 창안의 내용을 저장함.
         */
        savePackage: function () {
            // 컨펌 안끝났으면 저장안함
            if (!this.modalAllConfirmed) {
                return;
            }


            // 모달안의 내용을 실제값으로 저장
            let modal = this.modalPackage;
            this.items[modal.index].weight = modal.weight;
            this.items[modal.index].volume_x = modal.volume_x;
            this.items[modal.index].volume_y = modal.volume_y;
            this.items[modal.index].volume_z = modal.volume_z;

            // 부피계산
            this.calcVolume(this.items[modal.index], this.unit);


            // 창 닫음
            UIkit.modal(this.$modalElement).hide();
        },

        /**
         * 부피무게/적용무게를 계산해준다.
         * @param pkg (object)패키지정보
         * @param unit (string)무게단위
         */
        calcVolume(pkg, unit) {
            // 부피무게
            let volume_weight = null;

            if (unit === 'lb') {
                volume_weight = this.parseNumber(pkg.volume_x)
                    * this.parseNumber(pkg.volume_y)
                    * this.parseNumber(pkg.volume_z)
                    / 166;
            } else {
                volume_weight = this.parseNumber(pkg.volume_x)
                    * this.parseNumber(pkg.volume_y)
                    * this.parseNumber(pkg.volume_z)
                    / this.volumeWeightConversionFactor;
            }


            // 적용무게
            let apply_weight = this.parseNumber(pkg.weight);
            if (volume_weight > apply_weight) {
                apply_weight = volume_weight;
            }

            pkg.volume_weight = Math.round(volume_weight * 100) / 100;
            pkg.apply_weight = Math.round(apply_weight * 100) / 100;
        },

        /**
         * packages 정보를 json 반환
         */
        getPackagesJson() {
            let arr = [];
            _.forEach(this.items, (pkg, key) => {
                let item = {
                    weight: pkg.weight,
                    volume_x: pkg.volume_x,
                    volume_y: pkg.volume_y,
                    volume_z: pkg.volume_z
                };
                arr.push(item);
            });
            return JSON.stringify({
                unit: this.unit,
                packages: arr,
            });
        },
        /**
         * 입력된 패키지정보가 올바른지 검증결과를 반환
         *  - 무게 0인 패키지가 있으면 안됨
         *  @return object {
         *      is_valid : 검증성공여부 boolean
         *      msg : 실패한경우 메세지
         *  }
         */
        isValidate: function () {

            /**
             * todo : 검증처리부분 대충작성함.
             * 나중에 검증기능 확대할때 재정의하는게 좋음
             */
            let validate = {
                is_valid: true,
                msg: null
            };
            let cmp = this;
            _.forEach(this.items, function (pkg, key) {
                if (cmp.parseNumber(pkg.weight) === 0) {
                    validate.is_valid = false;
                    validate.msg = cmp.validateMsgNeedWeight;
                }
            });

            return validate;
        },

        /**
         * 상품 추가
         * @param init 패키지 초기화 정보
         */
        add: function (init) {
            this.items.push(
                $.extend({
                    weight: null,
                    volume_x: null,
                    volume_y: null,
                    volume_z: null
                }, init)
            );
        },

        /**
         * 복사
         * @param index 선택한 배열 index
         */
        duplicate: function (index) {
            this.items.push($.extend({}, this.items[index]));

            //this.rebindAllProd();
        },
        /**
         * 제거
         * @param index 선택한 배열 index
         */
        remove: function (index) {
            if (!confirm(this.removeConfirm)) {
                return;
            }

            if (this.items.length <= 1) {
                alert(this.lastItemRemoveAlert);
                return;
            }
            //console.log('remove is '+index);
            this.items.splice(index, 1);
            //console.log(this.items);

            //this.rebindAllProd();

        }
    }
}
</script>

<style lang="scss" scoped>
.root {
    width: 100%;
    max-width: 100rem;
}


.modal-package {
    // 창 크기
    .uk-modal-dialog {
        width: auto;
    }

    .cell {
        padding: 5px;
        width: 12rem;
    }

    // 무게/부피글자 크기
    .weight,
    .volume {
        text-align: center;

        h4 {
            font-weight: bold;
            font-size: 1.125rem;
        }

        .unit {
            color: #999;
            font-size: 1rem;
            font-style: normal;
        }

    }

    // 중간무게 컨펌 메세지
    .medium-confirm-msg {

        padding: 5px;
        margin: 5px 0;
        color: #f0506e;
        font-size: 1.25rem;
    }


    // 큰 무게 컨펌 메세지
    .heavy-confirm-msg {

        padding: 5px;
        margin: 5px 0;
        color: #f0506e;
        font-size: 1.25rem;
    }


    // 큰 부피 컨펌 메세지
    .large-volume-confirm-msg {

        padding: 5px;
        margin: 5px 0;
        color: #f0506e;
        font-size: 1.25rem;
    }


}
</style>